import { ReactElement } from 'react'
import { useAppSelector } from 'src/store/hooks'
import BaseLayout from 'src/v3/components/base-layout'
import {
  CourseIcon,
  TemplateIcon,
  LearningPathIcon,
  SeriesIcon,
} from 'src/v3/core/icons'
import { selectRoles } from 'src/v3/settings/settings.slice'

interface Props {
  children: ReactElement | ReactElement[]
}

export default ({ children }: Props): ReactElement => {
  let roles = useAppSelector(selectRoles)
  let isAdmin = roles.includes('admin')

  let baseMenuItems = [
    {
      name: 'Courses',
      route: '/',
      icon: <CourseIcon />,
    },
    {
      name: 'Templates',
      route: '/templates',
      icon: <TemplateIcon />,
    },
    {
      name: 'Learning Paths',
      route: '/learning-paths',
      icon: <LearningPathIcon />,
    },
  ]

  let subMenuItems = isAdmin
    ? [
        ...baseMenuItems,
        {
          name: 'Series',
          route: '/series',
          icon: <SeriesIcon />,
        },
      ]
    : baseMenuItems

  return (
    <BaseLayout
      children={children}
      domain="create/v4"
      role="creator"
      subMenuItems={subMenuItems}
    />
  )
}
